// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6170":"css/app","6481":"css/v2/app"}[chunkId] + ".css";
};